import { render, staticRenderFns } from "./BlockViewer.vue?vue&type=template&id=7ae86560"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"
import style0 from "./BlockViewer.vue?vue&type=style&index=0&id=7ae86560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports